import { Injectable } from '@angular/core';

import { ConfigService, EntityService } from 'viggo-sistemas-core-web';

import { ICombustivel } from '../model/combustivel.model';

@Injectable()
export class CombustivelService extends EntityService<ICombustivel> {
  constructor(protected configService: ConfigService) {
    super(
      {
        baseEntityEndPoint: 'combustivel',
        pluralBaseEntityEndPoint: 'combustiveis',
        urlBackend: configService.backendURL
      }
    );
  }
}
